<template>
    <div class="absolute top-0 right-0 ml-16 h-screen max-w-xs overflow-y-auto bg-slate-300 px-6">
        <ul
            v-for="(item, index) in list"
            :key="index"
            class="divide-y-32"
        >
            <li class="my-6 rounded-sm">
                <img
                    :src="item.uri"
                    alt="~"
                    @click="action(item.uri)"
                />
                <div class="text-sm text-slate-700">
                    {{ item.fileName }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
    import { inject } from 'vue';
    import axios from 'axios';

    const config = inject('config'),
        list = [];

    const result = await axios.get(config.fileStorageUrl, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    });

    result.data.forEach((element) => {
        const fileLocation = element.replace('https://localhost/disk/', '');
        const position = fileLocation.lastIndexOf('/');
        list.push({
            uri: element,
            fileName: fileLocation.substring(position + 1),
            folder: fileLocation.substring(0, position),
        });
    });

    defineProps({
        action: {
            type: Function,
            default: () => {
                return [];
            },
        },
    });
</script>
